module.exports = __webpack_public_path__ + "media/images/redesign-images/shared/best-sellers/best-sellers-05-7345e9f797ceecb6061a86c53b7754bd.jpg";